import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'Marta R.',
    location: 'Bogotá',
    quote: 'Antes de leer El Protocolo, mis mañanas eran un caos de gritos y café frío. Hoy, esos 10 minutos son mi ancla. Mi esposo nota la diferencia y mi casa se siente... ligera. Por fin entiendo lo que es vivir en paz.',
    result: 'Paz mental en 7 días.'
  }, {
    name: 'Carlos J.',
    location: 'Ciudad de México',
    quote: 'Dudaba que algo tan corto funcionara. Pero los Salmos de Poder (Bonus 2) cambiaron cómo veo mis negocios. Ya no opero desde el miedo, sino desde la victoria. Es una inversión pequeña para un cambio eterno.',
    result: 'Claridad y enfoque espiritual.'
  }];
  return <section className="py-10 md:py-20 px-4 bg-teal-dark text-white relative overflow-hidden" data-id="element-147">
      {/* Decorative background */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-teal rounded-full blur-3xl opacity-50" data-id="element-148"></div>
      <div className="absolute bottom-0 left-0 w-64 h-64 bg-gold rounded-full blur-3xl opacity-20" data-id="element-149"></div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-150">
        <div className="text-center mb-6 md:mb-12" data-id="element-151">
          <h2 className="text-3xl md:text-4xl font-bold font-heading text-gold-light mb-4" data-id="element-152">
            Vidas Transformadas
          </h2>
          <div className="w-24 h-1 bg-gold mx-auto rounded-full" data-id="element-153"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-8" data-id="element-154">
          {testimonials.map((t, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.2
        }} className="bg-white text-charcoal p-5 md:p-8 rounded-2xl shadow-xl relative" data-id="element-155">
              <Quote className="absolute top-6 right-6 w-10 h-10 text-cream opacity-50" data-id="element-156" />

              <div className="flex gap-1 mb-4" data-id="element-157">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-gold text-gold" data-id="element-158" />)}
              </div>

              <p className="text-lg italic mb-6 leading-relaxed" data-id="element-159">"{t.quote}"</p>

              <div className="mt-auto pt-4 border-t border-gray-100" data-id="element-160">
                <p className="font-bold font-heading text-teal-dark text-lg" data-id="element-161">
                  {t.name}
                </p>
                <p className="text-sm text-gray-500 mb-2" data-id="element-162">{t.location}</p>
                <div className="inline-block bg-cream text-teal-dark px-3 py-1 rounded-full text-sm font-medium border border-gold/30" data-id="element-163">
                  Resultado: {t.result}
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}